import { useEffect, useRef } from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import PageWrapper from '../../components/PageWrapper';
import features1 from '../../assets/images/oldManData.png';
import features2 from '../../assets/images/Aboutus2.png';
import calendar from '../../assets/images/calendar.png';
import bell from '../../assets/images/landingpage/notification.png';
import lab from '../../assets/images/landingpage/chemistry.png';
import team from '../../assets/images/landingpage/medicalteam.png';
import '../../styles/landing.scss';
const About = () => {
  const leftRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const setImageHeight = () => {
      // Only apply height matching on larger screens (md and above - 768px)
      if (window.innerWidth >= 768) {
        if (leftRef.current && imgRef.current) {
          // Add a small delay to ensure DOM is fully rendered
          setTimeout(() => {
            const contentHeight = leftRef.current.offsetHeight;
            imgRef.current.style.height = contentHeight + 'px';
            imgRef.current.style.maxHeight = 'none';
          }, 100);
        }
      } else {
        // Reset to auto on mobile
        if (imgRef.current) {
          imgRef.current.style.height = 'auto';
          imgRef.current.style.maxHeight = '350px';
        }
      }
    };

    setImageHeight();
    
    // Recalculate on window resize with debounce
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setImageHeight, 150);
    };
    
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimer);
    };
  }, []);

  return (
    <PageWrapper title="About Us">
      <Container className="px-3">
        <Row className="align-items-center mb-5">
          {/* IMAGE */}
          <Col lg={5} md={10} className="position-relative text-center">
            <Image
              ref={imgRef}
              src={features1}
              alt="About demo"
              className="about-image"
            />
          </Col>

          {/* CONTENT */}
          <Col lg={7} md={12} className="text-center text-lg-start">
            <div ref={leftRef}>
              <h6 className="text-uppercase text-muted">About Us</h6>
              <h2 className="mt-2 mb-3">
                Our Practice Excellent Care, Humane Principles
              </h2>

              <p className="text-muted">
                Et phasellus turpis vel fermentum cursus. Cursus mi placerat
                faucibus sapien purus odio arcu in. Amet dui mauris accumsan
                elit nec.Et phasellus turpis vel fermentum cursus. Cursus mi
                placerat faucibus sapien purus odio arcu in. Amet dui mauris
                accumsan elit nec.Et phasellus turpis vel fermentum cursus.
                Cursus mi placerat faucibus sapien purus odio arcu in. Amet dui
                mauris accumsan elit nec.Et phasellus turpis vel fermentum
                cursus. Cursus mi placerat faucibus sapien purus odio arcu in.
                Amet dui mauris accumsan elit nec.
              </p>

              {/* INFO CARDS */}
              <Row className="mt-4 g-3">
                {[
                  {
                    title: 'Super-Admin',
                    desc: 'Creates hospitals, assigns admins, and manages users.',
                  },
                  {
                    title: 'Admin',
                    desc: 'Manage locations, doctors, patients, reports and billing.',
                  },
                  {
                    title: 'Doctor',
                    desc: 'Appointments, calendar, notes, prescriptions and labs.',
                  },
                ].map((item, i) => (
                  <Col lg={4} md={6} sm={12} key={i}>
                    <Card className=" shadow-sm h-100">
                      <Card.Body>
                        <Card.Title className="fs-6 fw-bold">
                          {item.title}
                        </Card.Title>
                        <Card.Text className="small text-muted">
                          {item.desc}
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>

        <Row className="text-center my-4">
          <Col>
            <h2 className="fw-bold">Why HospEase Solution</h2>
            <div className="underline"></div>
          </Col>
        </Row>

        <Row className="align-items-center text-center text-lg-start px-3">
          {/* LEFT */}
          <Col xs={12} sm={12} md={4} lg={4} >
            <div className="d-grid gap-4">
              <div className="d-flex align-items-start justify-content-center justify-content-lg-start">
                <img
                  src={calendar}
                  alt="Calendar"
                  width={28}
                  height={28}
                  className="me-3 mt-1"
                />
                <div>
                  <h5 className="mb-1">Everything in one place</h5>
                  <p className="small text-muted mb-0">
                    Scheduling, patient records, lab workflows, and
                    e-prescriptions.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start justify-content-center justify-content-lg-start">
                <img
                  src={bell}
                  alt="Notifications"
                  width={28}
                  height={28}
                  className="me-3 mt-1"
                />
                <div>
                  <h5 className="mb-1">Reduce no-shows</h5>
                  <p className="small text-muted mb-0">
                    Smart reminders via Email/SMS/WhatsApp with flexible
                    cadences.
                  </p>
                </div>
              </div>
            </div>
          </Col>

          {/* CENTER IMAGE */}
          <Col xs={12} sm={12} md={4} lg={4} className="mb-4 text-center">
            <Image
              src={features2}
              alt="Doctor demo"
              fluid
              style={{ maxWidth: '70%' }}
            />
          </Col>

          {/* RIGHT */}
          <Col xs={12} sm={12} md={4} lg={4}>
            <div className="d-grid gap-4">
              <div className="d-flex align-items-start justify-content-center justify-content-lg-start">
                <img
                  src={lab}
                  alt="Lab"
                  width={28}
                  height={28}
                  className="me-3 mt-1"
                />
                <div>
                  <h5 className="mb-1">Faster lab TAT</h5>
                  <p className="small text-muted mb-0">
                    Structured test requests, real-time status and instant
                    result delivery.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start justify-content-center justify-content-lg-start">
                <img
                  src={team}
                  alt="Team"
                  width={28}
                  height={28}
                  className="me-3 mt-1"
                />
                <div>
                  <h5 className="mb-1">Built for teams</h5>
                  <p className="small text-muted mb-0">
                    Super-Admin, Admin, Doctor, Receptionist, Lab/Technician and
                    Patient portals.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </PageWrapper>
  );
};

export default About;
